import React, { useEffect, useState } from 'react'
import SectionHeader from '../../../../Components/GeneralComponents/SectionHeader'
import GuideLinks from '../../../../Components/GeneralComponents/GuideLinks'
import { useTranslation } from 'react-i18next'
import MeetingCard from '../../../../Components/Meetings/MeetingCard'
import { getMeetings } from '../../../../Requests/MeetingRequests'
import { getCredits, getTeamUuid } from '../../../../utils/cookies'
import { getProjects } from '../../../../Requests/ProjectRequests'
import CreateEditProjectSlideover from '../../../../Components/Projects/CreateEditProjectSlideover'
import ProjectCard from '../../../../Components/Projects/ProjectCard'
import { useMyContext } from '../../../../Components/ContextProviders/CreditsContextProvider'
import { updateCredits } from '../../../../Requests/TeamRequests'

function Projects() {
    const { t } = useTranslation()
    const [projects, setProjects] = useState(null)
    const [projectSlideover, setProjectSlideOver] = useState(null)

    const { credits, setCredits } = useMyContext();

    useEffect(() => {
        getProjects(getTeamUuid()).then((res) => {
            setProjects(res.data)
        }).catch((error) => {

        });
        updateCredits(getTeamUuid()).then((res) => {
            setCredits(res.data)
        }).catch((e) => {

        })
    }, [])


    return (
        <div data-testid="projects-container" className='md:pl-64 pt-4 md:pt-12 w-full flex justify-center'>
            <div data-testid="projects-content-wrapper" className='flex flex-col w-full justify-center items-center px-4'>
                <div data-testid="projects-header-card" className='bg-white max-w-7xl rounded-2xl w-full h-full shadow-xl mx-8'>
                    <SectionHeader data-testid="projects-section-header" title={t('Projects.Title')} subtitle={t('Projects.Subtitle')} actionTitle={t('Projects.ActionTitle')} actionFunction={() => { setProjectSlideOver(<CreateEditProjectSlideover handleClose={() => { setProjectSlideOver(null) }} />) }} />


                </div>
                {projects && <div data-testid="projects-grid" className='grid grid-cols-1 sm:grid-cols-2 justify-start py-4 max-w-7xl w-full flex-wrap gap-4'>
                    {projects.map((project) => {
                        return <ProjectCard data-testid={`project-card-${project.uuid}`} project={project} key={project.uuid} />
                    })}

                </div>
                }
                <GuideLinks page="projects" className="max-w-7xl w-full py-4" />
            </div>
            {projectSlideover && <div data-testid="project-slideover-modal">{projectSlideover}</div>}
        </div>
    )
}

export default Projects
